export default __webpack_public_path__ + "static/media/money-back@2x.a5530c9d.png";